class LamodaPixel extends Pixel
{
  onCartAdd (product)
  {
    dlApi.cmd.push(function(dlApi) {
      const products = [];

      products.push({
        name: product.title,
        id: product.product_id,
        price: (product.price / 100).toFixed(2),
        brand: product.vendor,
        category: product.product_type,
        variant: product.variant_options[0],
        qty: 1
      });

      dlApi.sendActivityEvent({
        network: window.lamodaConfig.network,
        event: 'add_to_cart',
        actgid: window.lamodaConfig.actgid,
        products: products,
        sitetype: 'list'
      })
    });
  }

  onCheckout (cart)
  {
    dlApi.cmd.push(function (dlApi) {
      const products = [];

      cart.items.forEach(product => {
        products.push({
          name: product.title,
          id: product.id,
          price: (product.price / 100).toFixed(2),
          brand: product.vendor,
          category: product.product_type,
          variant: product.variant_options[0],
          qty: product.quantity
        });
      });

      dlApi.sendActivityEvent({
        network: window.lamodaConfig.network,
        event: 'checkout',
        actgid: window.lamodaConfig.actgid,
        products: products
      })
    });
  }

  onProductPageView (product, variant)
  {
    dlApi.cmd.push(function (dlApi) {
      dlApi.sendActivityEvent({
        network: window.lamodaConfig.network,
        event: 'product_detail',
        actgid: window.lamodaConfig.actgid,
        products: [
          {
            name: product.title,
            id: product.product_id,
            price: (product.price / 100).toFixed(2),
            brand: product.vendor,
            category: product.product_type,
            variant: variant.options[0]
          }
        ],
        sitetype: 'product'
      })
    });
  }

  onFilterResult (collection, products)
  {
    dlApi.cmd.push(function (dlApi) {
      const items = [];

      products.forEach((product, index) => {
        items.push({
          name: product.title,
          id: product.id,
          price: (product.variants[0].price / 100).toFixed(2),
          brand: product.vendor,
          category: product.product_type,
          variant: product.variants[0].option1,
          position: index + 1
        });
      });

      dlApi.sendActivityEvent({
        network: 1746213,
        event: 'product_list',
        actgid: 3887,
        products: items,
        sitetype: 'list'
      })
    });
  }

  onCollectionPageView (collection, products)
  {
    dlApi.cmd.push(function (dlApi) {
      const items = [];

      products.forEach((product, index) => {
        items.push({
          name: product.title,
          id: product.id,
          price: (product.variants[0].price / 100).toFixed(2),
          brand: product.vendor,
          category: product.product_type,
          variant: product.variants[0].option1,
          position: index + 1
        });
      });

      dlApi.sendActivityEvent({
        network: 1746213,
        event: 'product_list',
        actgid: 3887,
        products: items,
        sitetype: 'list'
      })
    });
  }
}
